/**
 * 前端多语言解决方案
 */
import _ from "underscore";
import url from "c-url";
import LangPack from "./pack";

let lang = url.query("lang");
let tws = ["zh-SG", "zh-MO", "zh-TW", "zh-HK"];
let ars = [
  "ar-AE",
  "ar-BH",
  "ar-DZ",
  "ar-EG",
  "ar-IQ",
  "ar-JO",
  "ar-KW",
  "ar-LB",
  "ar-LY",
  "ar-MA",
  "ar-OM",
  "ar-QA",
  "ar-SA",
  "ar-SY",
  "ar-TN",
  "ar-YE",
];

if (!lang) {
  let systemLanguage = navigator.language || navigator.browserLanguage;
  let _systemLanguage = systemLanguage.toLowerCase();

  switch (_systemLanguage) {
    case "ar":
      systemLanguage = "ar-EG";
      break;
    case "vi":
      systemLanguage = "vi-VN";
      break;
    case "en":
      systemLanguage = "en-US";
      break;
    case "ja":
      systemLanguage = "ja-JP";
      break;
    case "zh":
      systemLanguage = "zh-CN";
      break;
    default:
      break;
  }

  let arr = systemLanguage.split("-");

  if (arr.length > 1) {
    systemLanguage = arr[0] + "-" + arr[1].toUpperCase();
  } else {
    systemLanguage = "en-US";
  }

  if (
    systemLanguage == "zh-CN" ||
    systemLanguage == "ja-JP" ||
    systemLanguage == "vi-VN"
  ) {
    lang = systemLanguage;
  } else if (tws.indexOf(systemLanguage) >= 0) {
    lang = "zh-TW";
  } else if (ars.indexOf(systemLanguage) >= 0) {
    lang = "ar-EG";
  } else {
    lang = "en-US";
  }
}

let langType = lang.replace("-", "").toLowerCase();
let langPack = LangPack[langType] || LangPack["zhcn"];

let _lang = {
  type: lang,

  init: function () {
    $("html").attr("lang", lang);
    $("body").addClass(langType);
  },

  template: function (tplStr, data, insertEM) {
    let tpl = langPack[tplStr] || tplStr;
    let feature = url.query("feature");
    // console.log(tplStr, langPack, langPack[tplStr]);
    if (tpl) {
      if (tpl.indexOf("@@@@") > 0) {
        let strArr = [];

        strArr.push("<ul>");
        tpl.split("@@@@").forEach(function (item, index) {
          item && strArr.push("<li>" + item + "</li>");
        });
        strArr.push("</ul>");
        tpl = strArr.join("");
      }
      if (insertEM) {
        tpl = tpl.replace(/<%=([\s\S]+?)%>/g, function ($0, $1) {
          return '<em class="' + $1 + '">' + $0 + "</em>";
        });
      }

      let compiled = _.template(tpl);
      if (feature == 6666) {
        return compiled(data).replace("Uplive", "Haya");
      } else if (feature == 777) {
        return compiled(data).replace("Uplive", "Bubbly");
      } else if (feature == 1001) {
        return compiled(data).replace("Uplive", "Up Ludo");
      } else if (feature == 1002) {
        return compiled(data).replace("Uplive", "Up Domino");
      } else if (feature == 10001) {
        return compiled(data).replace(/Up直播|Uplive/g, "Love Live");
      } else if (feature == 10002) {
        return compiled(data).replace(/Up直播|Uplive/g, "Spark Live");
      } else {
        return compiled(data);
      }
    } else {
      if (feature == 6666) {
        return _.template(tplStr)(data).replace("Uplive", "Haya");
      } else if (feature == 777) {
        return _.template(tplStr)(data).replace("Uplive", "Bubbly");
      } else if (feature == 1001) {
        return _.template(tplStr)(data).replace("Uplive", "Up Ludo");
      } else if (feature == 1002) {
        if (!tplStr) return "";
        return _.template(tplStr)(data).replace("Uplive", "Up Domino");
      } else if (feature == 10001) {
        return compiled(data).replace(/Up直播|Uplive/g, "Love Live");
      } else if (feature == 10002) {
        return compiled(data).replace(/Up直播|Uplive/g, "Spark Live");
      } else {
        return _.template(tplStr)(data);
      }
    }
  },
};

_lang.init();

module.exports = _lang;



// WEBPACK FOOTER //
// ./js/lang/index.js